import { Paragraph, WrapMdMarginBottom } from "App/global-style";
import { Label, Validation } from "Components/TextContext/commonComponentEnums";

import { PostNumberInput } from "Components/Form/PostNumberInput";
import { useTexts } from "Components/TextContext";
import { ThemedSpinner } from "Components/Themes/components/ThemedSpinner";
import { FormikProps } from "formik";
import React from "react";
import { useDispatch } from "react-redux";
import { useFetchedCity } from "Store/postNumber/postNumberHooks";
import { fetchCityStart } from "Store/postNumber/postNumberSlice";
import { getError } from "Utils/productUtils";
import { capitalizeFirstLetter } from "Utils/stringUtils";

interface PostNumber {
  validPostNumber?: boolean;
  postNumber?: string;
  city?: string;
}

interface Props<T extends PostNumber = PostNumber> {
  formProps: FormikProps<T>;
  label?: string;
  hint?: string;
  labelPopover?: React.ReactElement;
}

export const PostNumberAndCity = ({
  formProps,
  label,
  hint,
  labelPopover,
}: Props): React.ReactElement => {
  const { getText } = useTexts();
  const invalidPostNumberText = getText(Validation.POSTNUMBER_INVALID);

  const postNumberCity = useFetchedCity(
    "city",
    formProps,
    invalidPostNumberText,
  );
  const dispatch = useDispatch();

  const getCityName = (postNumber: string): void => {
    if (postNumber.length === 4) {
      dispatch(fetchCityStart(postNumber));
    }
  };

  return (
    <WrapMdMarginBottom
      aria-live="polite"
      aria-busy={postNumberCity.isLoading}
      className="data-hj-suppress"
    >
      <PostNumberInput
        id="postNumber"
        name="postNumber"
        label={label ?? getText(Label.POST_NUMBER)}
        hint={hint}
        error={getError("postNumber", formProps)}
        postNumber={formProps.values.postNumber}
        onChange={getCityName}
        labelPopover={labelPopover}
      />
      {postNumberCity.isLoading ? (
        <ThemedSpinner />
      ) : (
        formProps.values.city &&
        formProps.values.city.length > 0 &&
        formProps.values.city !== invalidPostNumberText && (
          <Paragraph role="status">
            {`${getText(Label.CITY)}: ${capitalizeFirstLetter(
              formProps.values.city,
            )}`}
          </Paragraph>
        )
      )}
    </WrapMdMarginBottom>
  );
};
